import { useContext } from 'react';
import { AnalyticsContext } from 'shared/providers/analytics/AnalyticsContext';

/**
 * @deprecated Kept only for test backward compatibility. Use `useAnalytics` directly in runtime code instead.
 */
export const useAnalyticsConfiguration = () => {
  const context = useContext(AnalyticsContext);
  if (!context) {
    throw new Error(
      'useAnalyticsConfiguration must be used within a AnalyticsProvider',
    );
  }
  return context;
};
